export const getters = {
    columns: state => state.columns,
};
